import { cloneDeep } from "lodash";
import { initialState } from "../initialState";
import { fileActions as actions } from "../actions";
import { createReducer, methodSwitcher } from "./utilities";

const { file } = initialState;

const clearCurrent = (state) => ({ ...state, current: {} });

const setFileList = (state, { data }) => {
  const newState = cloneDeep(state);
  newState.list = data;
  return newState;
};

const setCurrentFile = (state, { data }) => {
  const newState = cloneDeep(state);
  newState.current = data;
  return newState;
};

const actionFile = (state, { data, id, method }) => {
  const newState = cloneDeep(state);
  methodSwitcher(newState, data, id, method);
  return newState;
};

export const fileReducer = createReducer(file, {
  [actions.LIST]: setFileList,
  [actions.CLEAR_CURRENT]: clearCurrent,
  [actions.CURRENT]: setCurrentFile,
  [actions.CUD]: actionFile,
});
